export const formatMinutesToHours = (minutes: number) => {
  if (minutes < 60) {
    return `${minutes} min`;
  }
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return remainingMinutes > 0 ? `${hours}h ${remainingMinutes} min` : `${hours}h`;
};

type SelectOption = {
  label: string;
  value: string;
};

export const generateDurationOptions = (): SelectOption[] => {
  const options: SelectOption[] = [];
  for (let minutes = 10; minutes <= 60; minutes += 5) {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    const label =
      hours > 0
        ? `${hours}:${mins.toString().padStart(2, '0')}`
        : `0:${mins.toString().padStart(2, '0')}`;
    options.push({ label, value: minutes.toString() });
  }
  return options;
};
